export const SITE_RECONSTRUCTION_MESSAGE =
  "Запись временно недоступна: сайт находится на реконструкции.";

const DEFAULT_TITLE = "Внимание";
const DEFAULT_MESSAGE =
  "Сайт временно на реконструкции. Часть функций сейчас недоступна. Скоро здесь будет много интересного.";

const BANNER_ID = "site-maintenance-banner";
const ATTENTION_CLASS = "is-attention";
const ALLOWED_SEVERITIES = new Set(["info", "warning", "critical", "success"]);

let bannerState = {
  loadedFromApi: false,
  enabled: false,
  bookingDisabled: false,
  title: DEFAULT_TITLE,
  message: DEFAULT_MESSAGE,
  note: "",
  severity: "warning",
  siteEnabled: true,
  holidayStyleActive: false,
  version: "",
  updatedAt: "",
};

function toSafeText(value, fallback = "") {
  const text = String(value ?? "").replace(/\s+/g, " ").trim();
  return text || fallback;
}

function toBool(value, fallback = false) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    if (!v) return fallback;
    if (["true", "1", "yes", "y", "on", "да"].includes(v)) return true;
    if (["false", "0", "no", "n", "off", "нет"].includes(v)) return false;
  }
  return fallback;
}

function normalizeSeverity(value, fallback = "warning") {
  const norm = toSafeText(value, fallback).toLowerCase();
  return ALLOWED_SEVERITIES.has(norm) ? norm : fallback;
}

function pickField(source, key, fallback = undefined) {
  if (!source || typeof source !== "object") return fallback;
  if (key in source) return source[key];
  return fallback;
}

export function applyMaintenanceBannerPayload(payload) {
  const source = payload && typeof payload === "object" ? payload : {};
  const enabled = toBool(pickField(source, "enabled", bannerState.enabled), bannerState.enabled);
  const bookingDisabled = toBool(
    pickField(
      source,
      "bookingDisabled",
      pickField(
        source,
        "isBookingDisabled",
        pickField(source, "disableBooking", bannerState.bookingDisabled)
      )
    ),
    false
  );
  const siteEnabled = toBool(pickField(source, "siteEnabled", bannerState.siteEnabled), bannerState.siteEnabled);
  const holidayStyleActive = toBool(
    pickField(source, "holidayStyleActive", bannerState.holidayStyleActive),
    bannerState.holidayStyleActive
  );

  bannerState = {
    loadedFromApi: true,
    enabled,
    bookingDisabled,
    title: toSafeText(pickField(source, "title", ""), DEFAULT_TITLE),
    message: toSafeText(pickField(source, "message", ""), DEFAULT_MESSAGE),
    note: toSafeText(pickField(source, "note", ""), ""),
    severity: normalizeSeverity(pickField(source, "severity", "warning"), "warning"),
    siteEnabled,
    holidayStyleActive,
    version: toSafeText(pickField(source, "version", ""), ""),
    updatedAt: toSafeText(pickField(source, "updatedAt", ""), ""),
  };

  return { ...bannerState };
}

export function getMaintenanceBannerState() {
  return { ...bannerState };
}

export function isBookingTemporarilyDisabled() {
  // Баннер о реконструкции может быть включен как информационный.
  // Запись блокируем только отдельным флагом `bookingDisabled`.
  return Boolean(bannerState.bookingDisabled);
}

export function triggerMaintenanceBanner(toast, message = SITE_RECONSTRUCTION_MESSAGE) {
  if (!isBookingTemporarilyDisabled()) return;
  const fallbackMessage = bannerState.message || SITE_RECONSTRUCTION_MESSAGE;
  const msg = toSafeText(message || fallbackMessage, fallbackMessage);

  if (typeof document !== "undefined") {
    const banner = document.getElementById(BANNER_ID);
    if (banner) {
      banner.classList.remove(ATTENTION_CLASS);
      // Restart animation on repeated clicks.
      void banner.offsetWidth; // eslint-disable-line no-unused-expressions
      banner.classList.add(ATTENTION_CLASS);
      banner.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  if (toast?.info) {
    toast.info(msg, { title: "Реконструкция" });
  }
}
